import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="-1 -1 18 18" fill="none">
    <path
      d="M0.833328 8C0.833328 4.04196 4.04195 0.833336 7.99999 0.833336C11.5931 0.833336 14.5678 3.47711 15.0866 6.92562C15.1277 7.19869 14.9396 7.45336 14.6666 7.49444C14.3935 7.53552 14.1388 7.34745 14.0978 7.07438C13.6515 4.10788 11.0909 1.83334 7.99999 1.83334C4.59424 1.83334 1.83333 4.59424 1.83333 8C1.83333 11.4057 4.59424 14.1667 7.99999 14.1667C10.2473 14.1667 12.2147 12.9645 13.2927 11.1667H11.3333C11.0572 11.1667 10.8333 10.9428 10.8333 10.6667C10.8333 10.3905 11.0572 10.1667 11.3333 10.1667H14.101C14.1084 10.1665 14.1159 10.1665 14.1234 10.1667H14.2667C14.7637 10.1667 15.1667 10.5696 15.1667 11.0667V14C15.1667 14.2761 14.9428 14.5 14.6667 14.5C14.3905 14.5 14.1667 14.2761 14.1667 14V11.6535C12.9182 13.7562 10.6243 15.1667 7.99999 15.1667C4.04195 15.1667 0.833328 11.958 0.833328 8Z"
      fill="currentColor"
    />
    <path
      d="M7.99999 3.5C8.27614 3.5 8.49999 3.72386 8.49999 4V7.5H12C12.2761 7.5 12.5 7.72386 12.5 8C12.5 8.27614 12.2761 8.5 12 8.5H7.99999C7.72385 8.5 7.49999 8.27614 7.49999 8V4C7.49999 3.72386 7.72385 3.5 7.99999 3.5Z"
      fill="currentColor"
    />
  </SvgIcon>
));
